import ScanToSvgIcon from "@components/Common/SvgIcons/ScanToSvgIcon";
import ServioSvgIcon from "@components/Common/SvgIcons/ServioSvgIcon";

export type CardMenuType = {
    Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    description?: string;
    title: string;
    number: number;
    path: string;
};

export const CARD_MENU_LIST: CardMenuType[] = [
    {
        title: "Scan to",
        number: 0,
        Icon: ScanToSvgIcon,
        description:
            "Configuration of the Scan to application. Set up QR code scanning options, order processing, and customer interaction settings.",
        path: "/scan-to",
    },
    {
        title: "Servio",
        number: 0,
        Icon: ServioSvgIcon,
        description:
            "Configuration of the Servio application. Manage service settings, table assignments, and waiter call functionality.",
        path: "/servio",
    },
];
